import { HTTPError } from '@funtech-int/web-toolkit';

export class PersonNotFoundError extends HTTPError {
    constructor(id: number) {
        super(404, `Person not found, id ${id}`, '');
    }
}
